import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

const exportToExcel = (data, companyName, fileName = "Canceled_Invoices.xlsx") => {
  if (!data || data.length === 0) {
    Swal.fire("No data available for export", "", "warning");
    return;
  }

  // Process invoice data
  let formattedData = [];

  data.forEach((invoice, invoiceIndex) => {
    formattedData.push({
      "S.No": invoiceIndex + 1,
      "Invoice Number": invoice.invoice_number,
      "Customer Name": invoice.partyname,
      "Buyer Address": invoice.buyeraddress,
      "Ship To Address": invoice.ShipToAddress,
      "Total Amount": invoice.total_amount,
      "Tax Amount": invoice.Total_TaxAmount,
      "Taxable Amount": invoice.taxable_amt,
      "Invoice Date": invoice.date,
      "Due Date": invoice.due_date,
      "Payment Mode": invoice.pay_mode || "N/A",
      "Outstanding": invoice.outstanding,
    });
  });

  const ws = XLSX.utils.json_to_sheet([]);
  XLSX.utils.sheet_add_aoa(
    ws,
    [
      ["Canceled Invoices"],
      [`Company Name: ${companyName}`],
      [],
    ],
    { origin: "A1" }
  );
  XLSX.utils.sheet_add_json(ws, formattedData, { origin: "A4" });

  // Set column width for better readability
  const wscols = [
    { wch: 10 }, // S.No
    { wch: 15 }, // Invoice Number
    { wch: 20 }, // Customer Name
    { wch: 25 }, // Buyer Address
    { wch: 25 }, // Ship To Address
    { wch: 15 }, // Total Amount
    { wch: 15 }, // Tax Amount
    { wch: 15 }, // Taxable Amount
    { wch: 15 }, // Invoice Date
    { wch: 15 }, // Due Date
    { wch: 15 }, // Payment Mode
    { wch: 15 }, // Outstanding
  ];
  ws["!cols"] = wscols;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Canceled Invoices");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(dataBlob, fileName);

  Swal.fire({
    position: "top-end",
    icon: "success",
    title: "Your Excel file has been downloaded",
    showConfirmButton: false,
    timer: 1500,
  });
};

export default exportToExcel;
